import React, { useEffect, useState } from "react";
import { Card, CardContent, CircularProgress, CardHeader, Paper, Grid } from "@material-ui/core";
import { useTranslation } from "react-i18next";

import httpClient from "../../lib/httpClient";
import AgriculturePolicyDetailsMap from "../map/AgriculturePolicyDetailsMap";
import { AgriculturePolicyDescription } from "./AgriculturePolicyDescription";
import { getHazardsByUserAndPage } from "../riskAssessment/hazardUtils";
import { ParcelsList } from "./ParcelsList";
import { PerilsList } from "./PerilsList";
import { AgrClaimsList } from "./AgrClaimsList";

import { AgriculturePolicyDetails } from "../riskAssessment/hazardIdEnum";
import { HazardsAssessmentNoTabs } from "../riskAssessment/HazardsAssessment";
import { HazardProvider } from "../riskAssessment/HazardMapContext";

import { saveUserMonitorData } from "../util/userUtils";
import { apiError } from "../../lib/apiError";

// TODO: find a type for props, policy and claim
export const AgriculturePolicyShow = (props: any) => {
  const agrPolicyNumber = props.match.params.id.toString();
  const { t } = useTranslation();
  const [hazardsList, setHazardsList] = useState([] as Hazard[]);
  const [agriculturePolicy, setAgriculturePolicy] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [latitude, setLatitude] = useState(null);
  const [currentlyVisiblePartitas, setCurrentlyVisiblePartitas] = useState({});

  useEffect(() => {
    const currentHazards = getHazardsByUserAndPage(AgriculturePolicyDetails);
    setHazardsList(currentHazards);
  }, []);

  useEffect(() => {
    if (agrPolicyNumber) {
      saveUserMonitorData("agriculturePolicyShow", agrPolicyNumber);

      httpClient()
        .get(`/agriculturePolicies/${agrPolicyNumber}`)
        .then((res) => res.data)
        .then(async (data) => {
          const currPolicy = data[0];
          setAgriculturePolicy(currPolicy);
          setLongitude(currPolicy.location[0]);
          setLatitude(currPolicy.location[1]);
        })
        .catch((error) => {
          console.error("Error fetching agriculture policy: ", error);
          apiError(error);
        });
    }
  }, [agrPolicyNumber]);

  return agriculturePolicy ? (
    <HazardProvider>
      <Grid container style={{ marginTop: 15 }} spacing={2}>
        <Grid item xs={12} sm={4}>
          <Card style={{ height: "100%" }}>
            <Paper style={{ height: "100%" }}>
              <CardHeader title={t("policy.description")} />
              <CardContent style={{ paddingTop: "0" }}>
                <AgriculturePolicyDescription policy={agriculturePolicy} />
              </CardContent>
            </Paper>
          </Card>
        </Grid>

        <Grid item xs={12} sm={8}>
          <Card>
            {latitude && longitude && (
              <AgriculturePolicyDetailsMap
                policyNumber={agrPolicyNumber}
                longitude={longitude}
                latitude={latitude}
                currentlyVisiblePartitas={currentlyVisiblePartitas}
              />
            )}
          </Card>
        </Grid>

        <Grid item xs={12} sm={12}>
          {latitude && longitude ? (
            <HazardsAssessmentNoTabs
              hazardsList={hazardsList}
              latitude={latitude}
              longitude={longitude}
            ></HazardsAssessmentNoTabs>
          ) : (
            <Grid container justifyContent="center">
              <CircularProgress />
            </Grid>
          )}
        </Grid>

        <Grid item xs={12} sm={12}>
          <ParcelsList
            policyNumber={agrPolicyNumber}
            setCurrentlyVisiblePartitas={setCurrentlyVisiblePartitas}
            currentlyVisiblePartitas={currentlyVisiblePartitas}
          />
        </Grid>

        <Grid item xs={12} sm={12}>
          <PerilsList policyNumber={agrPolicyNumber} />
        </Grid>

        <Grid item xs={12} sm={12}>
          <AgrClaimsList policyNumber={agrPolicyNumber} />
        </Grid>
      </Grid>
    </HazardProvider>
  ) : (
    <> </>
  );
};
